import { useEffect } from "react";

// Pagine riservate: fuori dagli indici dei motori di ricerca.
export const useNoIndex = (title) => {
  useEffect(() => {
    document.title = title;
    let el = document.head.querySelector('meta[name="robots"]');
    if (!el) {
      el = document.createElement("meta");
      el.setAttribute("name", "robots");
      document.head.appendChild(el);
    }
    const precedente = el.getAttribute("content");
    el.setAttribute("content", "noindex, nofollow");
    return () => el.setAttribute("content", precedente || "index, follow");
  }, [title]);
};
